import { Host, h } from '@stencil/core';
// import { ClickOutside } from '../../../utils/click-outside';
export class AibaSelect {
  constructor() {
    this.componentDidLoad = () => {
      var _a;
      this.optionsRef = (_a = this.optionsRef) === null || _a === void 0 ? void 0 : _a.children;
      if (this.initialValue && this.options.includes(this.initialValue)) {
        this.inputRef.value = this.initialValue;
        this.value = this.initialValue;
      }
      if (!this.disabled && this.selectRef && this.optionsRef) {
        this.selectRef.onclick = event => {
          this.selectContainerRef.classList.toggle('active');
          this.selectClicked = !this.selectClicked;
          event.stopPropagation();
        };
      }
    };
    // @ClickOutside()
    // handleClickOutside() {
    //   this.selectContainerRef.classList.remove('active');
    //   this.selectClicked = false;
    // }
    this.handleClickOption = (event) => {
      var _a;
      this.selectClicked = true;
      this.inputRef.value = event.target.innerText;
      this.value = this.inputRef.value;
      this.selectContainerRef.classList.remove('active');
      const optionList = this.optionsRef.children;
      (_a = [...optionList]) === null || _a === void 0 ? void 0 : _a.forEach(e => {
        e.classList.remove('selected');
      });
      event.target.classList.add('selected');
    };
    this.renderOptionList = () => {
      var _a;
      const optionArray = [];
      (_a = this.options) === null || _a === void 0 ? void 0 : _a.forEach((option) => {
        option &&
          optionArray.push(h("label", { class: "option padding-l-sm-1", onClick: event => this.handleClickOption(event) }, option));
      });
      return (h("div", { class: "option-container", ref: el => (this.optionsRef = el) }, ...optionArray));
    };
    this.styles = undefined;
    this.classes = undefined;
    this.label = undefined;
    this.labelTransition = true;
    this.disabled = false;
    this.placeholder = undefined;
    this.name = undefined;
    this.selectIndex = undefined;
    this.initialValue = undefined;
    this.value = '';
    this.selectClicked = false;
    this.options = undefined;
    this.class = undefined;
    this.parentId = undefined;
  }
  componentDidUpdate() {
    if (this.value) {
      this.selectValue.emit({ name: this.name, value: this.value, index: this.selectIndex, parentId: this.parentId });
    }
    if (!this.disabled && this.selectRef && this.optionsRef) {
      this.selectRef.onclick = event => {
        this.selectContainerRef.classList.toggle('active');
        this.selectClicked = !this.selectClicked;
        event.stopPropagation();
      };
    }
  }
  render() {
    if (typeof this.options === 'string') {
      if (this.options)
        this.options = JSON.parse(this.options);
    }
    return (h(Host, null, this.styles && h("style", null, this.styles), h("div", { class: `select-container ${this.selectIndex ? `select-item-${this.selectIndex}` : ''}`, ref: el => (this.selectContainerRef = el) }, h("div", { class: this.classes ? this.classes : 'col-lg-12 col-sm-12' }, h("div", { class: `select ${this.disabled ? 'disabled' : ''}`, ref: el => (this.selectRef = el) }, this.label && !this.labelTransition && h("label", { class: "input-label" }, this.label), h("input", Object.assign({ type: "text", id: "input", name: this.name ? this.name : '', placeholder: this.selectClicked ? this.placeholder : ' ',
      // placeholder={this.placeholder}
      disabled: this.disabled, readOnly: true, ref: el => (this.inputRef = el), value: this.value }, (this.class && { class: this.class }))), this.label && this.labelTransition && h("label", { class: "input-label" }, this.label)), h("div", { class: 'option-list-container' }, h("span", null, this.renderOptionList()))))));
  }
  static get is() { return "aiba-select-input"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-select-input.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-select-input.css"]
    };
  }
  static get properties() {
    return {
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      },
      "labelTransition": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label-transition",
        "reflect": false,
        "defaultValue": "true"
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      },
      "placeholder": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "placeholder",
        "reflect": false
      },
      "name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "name",
        "reflect": false
      },
      "selectIndex": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "select-index",
        "reflect": false
      },
      "initialValue": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "''",
          "resolved": "\"\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "initial-value",
        "reflect": false
      },
      "options": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "options",
        "reflect": false
      },
      "class": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "class",
        "reflect": false
      },
      "parentId": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "parent-id",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "value": {},
      "selectClicked": {}
    };
  }
  static get events() {
    return [{
        "method": "selectValue",
        "name": "selectValue",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
}
//# sourceMappingURL=aiba-select-input.js.map
